<template>
  <main>
    <Header :loginSource="loginSource"></Header>

    <div class="watermark"></div>
    <div class="watermark2"></div>
    <section class="merchant_container" v-if="wrapper.course">
      <div class="merchant_wrapper">
        <div class="order_title">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/course', query: {no: no, activeName: 'fourth'} }">返回课程</el-breadcrumb-item>
            <el-breadcrumb-item>{{wrapper.course.name}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{wrapper.material.name}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <hr>
<!--        <div class="merchant_block" v-html="material.content">-->
<!--        </div>-->
        <iframe style="height: 100vh; margin-bottom: 20px;" :src="wrapper.material.url" frameborder="0"></iframe>
      </div>
    </section>

    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { getPhone } from '@/common/auth'
import {
  reqGetCourseMaterial,
  // reqCheckBuyCourse
} from '@/api'

export default {
  name: 'Material',
  components: {Header, Footer},
  comments: {
    Header
  },

  data() {
    return {
      no: parseInt(this.$route.query.no), // 课程编号
      id: parseInt(this.$route.query.id), // 资料ID
      wrapper: {},
      loginSource: 2*1000 + parseInt(this.$route.query.no),
      isBuyCourse: false,
      loginPhone: '',
    }
  },

  async mounted () {
    // 注意, 打开新窗口后，拿不到上个页面往vue state设置的数据

    this.loginPhone = getPhone()

    if (!this.loginPhone || !this.no || !this.id) {
      await this.$router.replace('/index')
      return
    }
    // await this.checkBuyCourse()

    await this.getCourseMaterial()
  },

  methods: {
    // async getCourseVideos () {
    //   const result = await reqFindCourseVideos(this.no)
    //   if (result.code === 0) {
    //     const courseWrapper = result.data
    //     await this.$store.dispatch('setCourseWrapper', {courseWrapper})
    //   }
    // },

    async getCourseMaterial () {
      const result = await reqGetCourseMaterial(this.no, this.id)
      if (result.code === 0) {
        this.wrapper = result.data
      } else {
        await this.$alert(`${ result.message }`, '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.push({
              path: '/course',
              query: {no: this.no, activeName: 'fourth'}
            }).catch(err=>{})
          }
        })
      }
    },

  },

  computed: {
    // ...mapState(['courseWrapper']),
    // ...mapState(['material']),
  },

}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  img {
    width: 400px;
    height: 300px;
  }

  .watermark {
    position: fixed;
    top: 150px;
    right: 50px;
    width: 270px;
    height: 85px;
    opacity: 0.70;
    background: url("/static/images/watermark.png") no-repeat scroll center 0/cover;
  }

  .watermark2 {
    position: fixed;
    bottom: 150px;
    right: 50px;
    width: 270px;
    height: 85px;
    opacity: 0.70;
    background: url("/static/images/watermark.png") no-repeat scroll center 0/cover;
  }

  .logo_search_container {
    display: flex;
    width: 100%;
    margin: 0px auto;
  }


  .merchant_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*background: #eee;*/
  }

  .merchant_wrapper {
    width: 100%;
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }

  .order_title {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 18px;
    font-weight: 500;
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_content {
    display: flex;
  }

  .storefront_image {
    width: 320px;
    height: 260px;
    border-radius: 6px;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid;
  }

  .merchant_desc {
    display: flex;
    flex-direction: column;
  }

  .merchant_name {
    cursor: pointer;
  }

  .merchant_desc div:first-child {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    /*font-size: 14px;*/
    /*color: #999;*/
  }

  .merchant_item {
    font-size: 14px;
    color: #333;
  }

  .merchant_higher_price {
    font-size: 16px;
    color: #999;
    text-decoration:line-through;
  }

  .merchant_lower_price {
    font-size: 18px;
    color: #CC0033;
    font-weight: bold;
  }

  .video_menu_wrapper {
    width: 320px;
    height: 680px;
    overflow: scroll;
    line-height: 30px;
    background: #eee;
    padding: 10px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Material/Material.vue